<template>
  <div class="large-12">
    <div class="row wrapper-spacing">
      <div class="medium-12 large-12 columns">
        <h3>Stichtag</h3>
        <div v-if="!showStyle" class="spv-select-group flex-no-wrap row">
          <div
            v-for="deadline_ in deadlines"
            :key="deadline_.id"
            class="small-6 medium-4 large-4 columns"
          >
            <div class="radio-input">
              <input
                :id="`trend-${ deadline_.id }`"
                :checked="deadline == deadline_.id"
                :value="deadline_.id"
                type="radio"
                name="trend-deadline"
                @change="onChangeDeadline(deadline_.id)"
              >
              <label :class="{ 'checked': deadline == deadline_.id }" :for="`trend-${ deadline_.id }`">
                <p>{{ deadline_.name }}</p>
              </label>
            </div>
          </div>
        </div>
        <div v-else class="spv-select-group">
          <div class="small-12 medium-6 large-4">
            <select :value="deadline" class="spv-input-select" @change="(e) => onChangeDeadline(e.target.value)">
              <option v-for="deadline_ in deadlines" :key="deadline_.id" :value="deadline_.id">
                {{ deadline_.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row wrapper-spacing">
      <div class="medium-12 large-6 columns">
        <h3>Zeitraum</h3>
        <div class="large-8">
          <select :value="year_" class="spv-input-select" @change="(e) => onSelectYear(e.target.value)">
            <option v-for="year in trend_years[deadline]" :value="year" :key="year">
              {{
                deadline === 1
                  ? `Jun ${ year } - Mai ${ year + 1 }`
                  : `Dez ${ year } - Nov ${ year + 1 }`
              }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row wrapper-spacing">
      <div class="medium-12 large-12 columns">
        <h1>Normierte Wertentwicklung TrendPortfolio Index {{ deadlines[deadline - 1].name }}</h1>
        <div class="large-12 columns spv-chart-wrapper">
          <index-chart
            v-show="deadline === 1"
            :data="trend_chart_items[1]"
            :max="trend_chart_max[1]"
            name="TrendPortfolio Index"
            color="#E81700"
          />
          <index-chart
            v-show="deadline === 2"
            :data="trend_chart_items[2]"
            :max="trend_chart_max[2]"
            name="TrendPortfolio Index"
            color="#E81700"
          />
          <div class="spv-price-inquiry">
            <b class="spv-price-inquiry__label">Kursabfrage</b>
            <div class="spv-price-inquiry__date-picker">
              <span>Datum</span>
              <date-picker
                :min="trend_max_dates[deadline].min_date"
                :max="trend_max_dates[deadline].max_date"
                :value="inquiry_date"
                @select="onSelectInquiryDate"
              />
            </div>
            <div class="spv-price-inquiry__value">
              <span v-if="!inquiry_valid && !inquiry_date" class="error-value">
                Bitte wählen Sie ein Datum
              </span>
              <span v-else-if="inquiry_value === -1" class="error-value">
                Für dieses Datum liegt kein Datensatz vor. Bitte wählen Sie ein anderes Datum aus
              </span>
              <span v-else-if="!!inquiry_value">
                TrendPortfolio Index&nbsp;&nbsp;<b>{{ inquiry_value }} Punkte</b>
              </span>
              <!-- <span v-else>&nbsp;</span> -->
            </div>
            <a class="button button-small block" @click="onGetInquiryValue">Anzeigen</a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="trendConfigText" class="row wrapper-spacing">
      <div class="medium-12 large-12 columns">
        <div v-html="trendConfigText" />
      </div>
    </div>

    <div class="row wrapper-spacing">
      <div v-if="details_data.index_values && details_data.index_values.length" class="medium-12 large-12 columns">
        <h1>
          <div class="spv-info-wrapper info-trend">
            Monatliche
            <div class="info-overlay">
              Wertentwicklung
              <div class="info-overlay__icon">
                <i class="fo icon-info_kreis" />
              </div>
              <div class="info-overlay__text" >
                {{ gloss_texts_trend[0] }}
              </div>
            </div>
          </div>
          <div class="spv-info-wrapper text-only">
            TrendPortfolio Index {{ deadlines[deadline - 1].name }}
          </div>
          <div class="spv-info-wrapper info-trend">
            <span class="text-normal">mit Zielvolatilität</span>
            <div class="info-overlay">
              <span class="text-normal">{{ formatPercent(details_data.target_vol, 2) }}</span>
              <div class="info-overlay__icon">
                <i class="fo icon-info_kreis" />
              </div>
              <div class="info-overlay__text">
                {{ gloss_texts_trend[1] }}
              </div>
            </div>
          </div>
        </h1>

        <div class="spv-table-wrapper">
          <table class="spv-product-table spv-index-table spv-index-table--trend">
            <thead>
              <tr>
                <th class="medium-8 large-9">Indexstichtag<br>{{ deadlines[deadline - 1].label }}{{ details_data.year }}</th>
                <th class="medium-4 large-3">
                  <div class="spv-info-wrapper flex-wrapper">
                    <span>Indexstand<br>jeweils am<br>Ende des Monats</span>
                    <div class="info-overlay">
                      <div class="info-overlay__icon header-info">
                        <i class="fo icon-info_kreis" />
                      </div>
                      <div class="info-overlay__text right-aligned" >
                        {{ gloss_texts_trend[2] }}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in details_data.index_values" :key="index">
                <td>{{ formatDate(data.date) }}</td>
                <td>{{ formatMoney(data.index_value, 2) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="td-padding">
                  <div class="spv-info-wrapper">
                    Jahresrendite
                    <div class="info-overlay">
                      <div class="info-overlay__icon">
                        <i class="fo icon-info_kreis" />
                      </div>
                      <div class="info-overlay__text right-auto" >
                        {{ gloss_texts_trend[3] }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ formatPercent(details_data.yearly_yield, 2) }}</td>
              </tr>
              <tr>
                <td>
                  <div class="spv-info-wrapper">
                    Maßgebliche
                    <div class="info-overlay">
                      Jahresrendite
                      <div class="info-overlay__icon">
                        <i class="fo icon-info_kreis" />
                      </div>
                      <div class="info-overlay__text right-auto" >
                        {{ gloss_texts_trend[4] }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ formatPercent(details_data.decisive_yearly_yield, 2) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="row pdf-button-wrapper d-flex">
          <div class="small-6 columns text-left">
            <a
              v-if="factsheet_path && factsheet_path[deadline]"
              class="button button-small"
              @click.stop="onDownloadFactsheet(factsheet_path[deadline])"
            >
              Download Factsheet
            </a>
          </div>

          <div class="small-6 columns text-right">
            <a class="button button-small" @click="onCreatePdf">
              Drucken
            </a>
          </div>
        </div>
      </div>

      <div v-else class="medium-12 large-12 columns">
        <h1 class="no-margin">Keine Monatswerte für Index TrendPortfolio für {{ deadlines[deadline - 1].name }} vorhanden.</h1>

        <div class="text-left mt-3">
          <a
            v-if="factsheet_path && factsheet_path[deadline]"
            class="button button-small"
            @click.stop="onDownloadFactsheet(factsheet_path[deadline])"
          >
            Download Factsheet
          </a>
        </div>
      </div>
    </div>

    <div v-if="lastConstituent" class="row wrapper-spacing">
      <div class="medium-12 large-12 columns">
        <h1>Zusammensetzung der Anlageklassen TrendPortfolio Index {{ deadlines[deadline - 1].name }}</h1>
        <p><b>Stand {{ `${ lastConstituent.month_name } ${ lastConstituent.year }` }}</b></p>
        <p>Die für den angegebenen Monat ausgewählten Anlageklassen sind in rot dargestellt.</p>
        <p>Die ausgewählten Anlageklassen gehen gleichgewichtet (zu je 25 %) in den Index ein. Falls weniger als vier Anlageklassen positive Trends aufzeigen und damit nicht in diesem Monat in den TrendPortfolio Index fließen, wird entsprechend weniger investiert.</p>

        <div class="spv-asset-classes">
          <template v-for="(item, index) in constituent_data[deadline]">
            <div :key="index" class="small-12 medium-6 large-4 spv-card-widget">
              <div :class="[ 'spv-card-widget__card', { 'marked': item.weight === 25 }]">
                <h2>{{ item.name }}</h2>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import mixin from './mixin';
import { b64DecodeUnicode } from '@/modules/utils';

export default {
  name: 'index_spv_trend',
  mixins: [ mixin ],

  data: () => ({
    deadlines: [
      {
        id: 1,
        name: 'Juni',
        label: '01.06.'
      },
      {
        id: 2,
        name: 'Dezember',
        label: '01.12.',
      }
    ],

    details_data: {},

    constituent_ids: [
      28505, 28498, 17216, 17215, 28503, 28502, 28623, 28622, 17217
    ],

    constituent_data: {
      1: [],
      2: []
    },

    trend_config: [],
    trend_max_dates: {
      1: {
        max_date: moment().format('YYYY-MM-DD'),
        min_date: moment().format('YYYY-MM-DD')
      },
      2: {
        max_date: moment().format('YYYY-MM-DD'),
        min_date: moment().format('YYYY-MM-DD')
      }
    },

    trend_years: {
      1: [],
      2: []
    },

    trend_chart_items: {
      1: [],
      2: []
    },

    trend_chart_max: {
      1: 0,
      2: 0
    },

    factsheet_path: {
      1: 0,
      2: 0
    }
  }),

  computed: {
    lastConstituent() {
      const length = this.constituent_data[this.deadline].length;

      if (!length) {
        return null;
      }

      return this.constituent_data[this.deadline][length - 1];
    },

    trendConfigText() {
      if (!this.trend_config || !this.trend_config.length) {
        return '';
      }

      let text = '';

      this.trend_config
        .filter(config => {
          if (this.deadline === 1 && config.config_key === 'trend_desc_graph_juni') {
            text = b64DecodeUnicode(config.config_value);
          }

          if (this.deadline === 2 && config.config_key === 'trend_desc_graph_dez') {
            text = b64DecodeUnicode(config.config_value);
          }
        });

      return text;
    }
  },

  methods: {
    loadIndexConfig () {
      this.loadTrendData(1);
      this.loadTrendData(2);
    },

    loadTrendData(deadline) {
      if (!this.apiRequest || this.trend_years[deadline].length > 0) {
        return;
      }

      this.apiRequest
        .get(this.config.paths.trend_years, {
          params: {
            data_type: deadline
          }
        })
        .then(res => {
          this.setTrendData(deadline, res.data);
        });
    },

    loadDetails() {
      let year_ = parseInt(this.year_);

      if (!year_ || isNaN(year_)) {
        return;
      }

      const params = {
        year: year_,
        data_type: this.deadline
      };

      this.apiRequest.get(this.config.paths.trend_details, {
        params
      })
        .then(res => {
          this.details_data = res.data.monthly_data || {};
        });
    },

    onChangeDeadline(value) {
      this.deadline = value;
      this.inquiry_value = '';
      this.inquiry_valid = false;
      this.inquiry_date = this.trend_max_dates[value].max_date;

      this.loadDetails();
    },

    onGetInquiryValue() {
      if (!this.inquiry_date) {
        this.inquiry_value = '';
        this.inquiry_valid = false;
        return;
      }

      this.inquiry_valid = true;

      let params = {
        date: this.formatDate(this.inquiry_date, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
        data_type: this.deadline
      };

      this.apiRequest.get(this.config.paths.trend_query, {
        params
      })
        .then(res => {
          this.inquiry_value = res.data.value
            ? this.formatMoney(res.data.value, 2)
            : -1;
        })
        .catch(err => {
          console.error(err);
          this.inquiry_value = -1;
        });
    },

    onDownloadFactsheet (id) {
      const params = {
        id
      };

      this.apiRequest
        .get(this.config.paths.factsheet_download, {
          params,
          responseType: 'blob'
        })
        .then(res => {
          this.downloadBlob(res.data, this.getFileNameFromHeader(res.headers, 'trend_fact_sheet.pdf'));
        });
    },

    setTrendData(deadline, data) {
      if (!data) {
        return;
      }

      this.trend_config = data.config_data.values || [];

      this.trend_max_dates[deadline] = data.config_data.max_dates
        .find(m => m.type === deadline) || {};

      this.trend_years[deadline] = (data.years || [])
        .sort((a, b) => b - a);

      this.year_ = this.trend_years[deadline][0];
      this.inquiry_date = this.trend_max_dates[1].max_date;
      this.factsheet_path = {
        1: data.fact_sheet_june,
        2: data.fact_sheet_dec
      };

      this.setTrendChartData(deadline, data);

      if (deadline === 1) {
        this.loadDetails();
      }
    },

    setTrendChartData(deadline, data) {
      this.trend_chart_max[deadline] = 0;

      this.trend_chart_items[deadline] = (data.index_data || [])
        .sort((a, b) => a.date > b.date ? 1 : -1)
        .map(item => {
          let value = parseFloat(item.index_value) ;

          if (value > this.trend_chart_max[deadline]) {
            this.trend_chart_max[deadline] = value;
          }

          return [
            moment(item.date).valueOf(),
            value
          ];
        });

      this.constituent_data[deadline] = (data.constituent_data || [])
        .map(item => {
          item.order = this.constituent_ids.indexOf(item.constituent_id);

          item.order = item.order === -1
            ? 99
            : item.order;

          return item;
        })
        .sort((a, b) => a.order - b.order);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/index/spv_trend.vue